import { createRouter, createWebHistory } from 'vue-router'
import { orchestador } from '@/router/orchestador'
import urlTokenGuard from '@/router/guards/url-token.guard'
import localStorageTokenGuard from '@/router/guards/local-storage-token.guard'
import tokenExpirationGuard from '@/router/guards/token-expiration.guard'
import { useMaintenanceSetup } from '@/shared/composables/useMaintenanceSetup'

const router = createRouter({
  history: createWebHistory(`${import.meta.env.VITE_APP_REDIRECT}/`),
  routes: orchestador()
})

const DEFAULT_GUARDS = [urlTokenGuard, localStorageTokenGuard, tokenExpirationGuard]

DEFAULT_GUARDS.forEach((guard) => router.beforeEach(guard))

router.beforeEach(async (to, from, next) => {
  const { setMaintenance } = useMaintenanceSetup()
  setMaintenance(to, from, next)
  next()
})

export default router
